export default {
    namespaced: true,
    state: () => ({}),
    getters: {},
    actions: {
        save: function ({ commit, dispatch }, { role, permissions }) {
            this.$xhr
                .post('/api/roles/' + role.id + '/permissions', { permissions })
                .then(d => dispatch('toast/success', { title: 'Opgeslagen', text: 'De rechten zijn opgeslagen bij deze rol' }, {root: true}))
                .catch(e => dispatch('toast/alert', { title: 'Mislukt!', text: 'Opslaan van rechten is mislukt.\n' + e.result.message + '\n' + Object.values(e.result.errors).flat().join('\n') }, {root: true}));
        },
        delete: function({dispatch}, role) {
            this.$xhr
                .delete('/api/roles/' + role.id)
                .then(
                    r => success(dispatch, 'Verwijderd', 'Rol ' + role.name + ' is verwijderd.'), window.location.href="/rollen-en-rechten"
                    )
                .catch(e => alert(dispatch, 'Mislukt', e.result.message));
        }
    },
    mutations: {}, 
    modules: {},
}

function success(dispatch, title, text) {
    dispatch('toast/success', {title, text}, {root: true});
}
function alert(dispatch, title, text) {
    dispatch('toast/alert', {title, text}, {root: true});
}